module.exports = __webpack_public_path__ + "files/56eccfca8894d9ee17af76a238df8ba1.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/droidserif-bold-webfont.ttf
// module id = 806
// module chunks = 60